<script lang="ts">
  import { refreshAll } from '$app/navigation';
  import Modal from '#lib/components/Modal.svelte';

  let { open = $bindable(false) }: { open: boolean } = $props();

  let files = $state<FileList>();
  let errorText = $state<string>();

  // let file = $derived(files?.item(0) as File);
</script>

<Modal header="Import JSON" bind:open>
  <form
    method="post"
    action="/timeSeries"
    enctype="multipart/form-data"
    onsubmit={async (e) => {
      e.preventDefault();

      const response = await fetch('/timeSeries', {
        method: 'POST',
        body: new FormData(e.currentTarget),
      });

      if (response.ok) {
        await refreshAll();
        open = false;
      } else {
        errorText = await response.text();
      }
    }}
  >
    <input
      type="file"
      name="file"
      class="file-input w-full"
      accept="application/json"
      placeholder="Pick or drag and drop the .json file"
      bind:files
    />
    {#if errorText}
      <div class="text-error my-1 text-sm">{errorText}</div>
    {/if}
    <div class="modal-action">
      <button class="btn btn-primary">Import</button>
    </div>
  </form>
</Modal>
